import { datatableTypes } from '@/typings'

type QueryParamsProps = {
	limit: number
	page: number
	sort?: datatableTypes.DatatableSort
	filters: datatableTypes.DatatableFilter[]
	initial?: boolean
	purge?: boolean
}

export const generateQueryParams = ({ limit, sort, page, filters, initial, purge }: QueryParamsProps) => {
	let qp = ''

	if (initial) {
		qp += 'initial=true&'
	}

	if (purge) {
		qp += 'purge=true&'
	}

	if (limit) {
		qp += `limit=${limit}&`
	}

	if (page) {
		qp += `page=${page}&`
	}

	qp +=
		sort && Object.keys(sort).length
			? `sort=${Object.keys(sort)
					.map((key) => `${key}:${sort[key]}`)
					.join(',')}&`
			: 'sort=&'

	if (filters && filters.length) {
		qp += filters
			.filter((item) => {
				if (typeof item.value === 'undefined' || item.value === null) {
					return false
				}
				if (typeof item.value === 'string') {
					return item.value.length
				}
				return true
			})
			.map((item) => `${item.dataKey}=${item.value}`)
			.join('&')
	}

	if (qp.length) {
		qp = `&${qp}`
	}

	return qp
}
